import {
  AnySignature_Read,
  DriverSignature_Read,
  DropoffSignature_Read,
  SignatureType,
} from '@treadinc/horizon-api-spec';

abstract class BaseSignature {
  constructor(
    private _id: string,
    private _lat: string | null,
    private _lon: string | null,
    private _image_url: string | null,
    private _image_mime_type: string | null,
    private _image_name: string | null,
    private _type: SignatureType,
    private _signable_type: string,
    private _signable_id: string,
  ) {}

  public get id() {
    return this._id;
  }

  public get lat() {
    return this._lat;
  }

  public get lon() {
    return this._lon;
  }

  public get imageUrl() {
    return this._image_url;
  }

  public get imageMimeType() {
    return this._image_mime_type;
  }

  public get imageName() {
    return this._image_name;
  }

  public get type() {
    return this._type;
  }

  public get signableType() {
    return this._signable_type;
  }

  public get signableId() {
    return this._signable_id;
  }
}

class DriverSignature extends BaseSignature {
  constructor(
    _id: string,
    _lat: string | null,
    _lon: string | null,
    _image_url: string | null,
    _image_mime_type: string | null,
    _image_name: string | null,
    _signable_type: string,
    _signable_id: string,
  ) {
    super(
      _id,
      _lat,
      _lon,
      _image_url,
      _image_mime_type,
      _image_name,
      SignatureType.DRIVER_SIGNATURE,
      _signable_type,
      _signable_id,
    );
  }

  public static parse(proto: DriverSignature_Read) {
    return new DriverSignature(
      proto.id,
      proto.lat,
      proto.lon,
      proto.image_url,
      proto.image_mime_type,
      proto.image_name,
      proto.signable_type,
      proto.signable_id,
    );
  }
}

class DropoffSignature extends BaseSignature {
  constructor(
    _id: string,
    _lat: string | null,
    _lon: string | null,
    _image_url: string | null,
    _image_mime_type: string | null,
    _image_name: string | null,
    _signable_type: string,
    _signable_id: string,
    private _name: string | null,
    private _phone: string | null,
  ) {
    super(
      _id,
      _lat,
      _lon,
      _image_url,
      _image_mime_type,
      _image_name,
      SignatureType.DROPOFF_SIGNATURE,
      _signable_type,
      _signable_id,
    );
  }

  public get name() {
    return this._name;
  }

  public get phone() {
    return this._phone;
  }

  public static parse(proto: DropoffSignature_Read) {
    return new DropoffSignature(
      proto.id,
      proto.lat,
      proto.lon,
      proto.image_url,
      proto.image_mime_type,
      proto.image_name,
      proto.signable_type,
      proto.signable_id,
      proto.name,
      proto.phone,
    );
  }
}

export type DriverDaySignature = DriverSignature | DropoffSignature;
export type JobLoadSignature = DriverSignature | DropoffSignature;
export type JobSignature = DriverSignature | DropoffSignature;

export class SignatureFactory {
  static create(proto: AnySignature_Read) {
    const isDropoffSignaturePrototype = 'name' in proto;

    if (isDropoffSignaturePrototype) {
      return new DropoffSignature(
        proto.id,
        proto.lat,
        proto.lon,
        proto.image_url,
        proto.image_mime_type,
        proto.image_name,
        proto.signable_type,
        proto.signable_id,
        proto.name,
        proto.phone,
      );
    }

    return new DriverSignature(
      proto.id,
      proto.lat,
      proto.lon,
      proto.image_url,
      proto.image_mime_type,
      proto.image_name,
      proto.signable_type,
      proto.signable_id,
    );
  }
}
